import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "audio-icon-container" }
const _hoisted_2 = ["src"]

import vue from '../../../../adapter-vue';
import Icon from '../../../common/Icon.vue';
import audioIcon1 from '../../../../assets/audio_icon_1.svg';
import audioIcon2 from '../../../../assets/audio_icon_2.svg';
import audioIcon3 from '../../../../assets/audio_icon_3.svg';
import { isMobile } from '../../../../utils/env';
import {
  Toast,
  TOAST_TYPE,
} from '../../../common/Toast/index-web';
import { TUITranslateService } from '../../../../@aidesk/uikit-engine';
interface IEmits {
  (e: 'setAudioPlayed', messageID: string): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'message-audio-web',
  props: {
  content: {
    type: Object,
    default: () => ({}),
  },
  messageItem: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ["setAudioPlayed"],
  setup(__props, { emit: __emit }) {

const { watchEffect, ref, onMounted, onUnmounted, computed } = vue;

const emits = __emit;
const props = __props;

const data = ref();
const message = ref();
const isAudioPlaying = ref();
const audioRef = ref<HTMLAudioElement>();
const audioIcons = [audioIcon1, audioIcon2, audioIcon3];
const currentAudioIconIndex = ref(2);
const audioUrl = ref('');
const currentAudioIcon = computed(() => audioIcons[currentAudioIconIndex.value]);
let audioIconTimer: any = null;

onMounted(() => {
  if (audioRef.value) {
    audioRef.value.addEventListener('ended', onAudioEnded);
    audioRef.value.addEventListener('pause', onAudioPaused);
  }
});

onUnmounted(() => {
  if (audioRef.value) {
    audioRef.value.removeEventListener('ended', onAudioEnded);
    audioRef.value.removeEventListener('pause', onAudioPaused);
  }
});

watchEffect(() => {
  message.value = props.messageItem;
  data.value = props.content;
  audioUrl.value = data.value.url || message.value.payload.remoteAudioUrl;
});

function play() {
  if (message.value.hasRiskContent || !audioRef.value) {
    return;
  }
  if (!audioRef.value.paused) {
    audioRef.value.pause();
    audioRef.value.currentTime = 0;
    isAudioPlaying.value = false;
    return;
  }
  const audios = document.getElementsByTagName('audio');
  Array.from(audios).forEach((audio) => {
    if (!audio.paused) {
      audio.pause();
      audio.currentTime = 0;
    }
  });
  try {
    if (!audioUrl.value) {
      const message = `${TUITranslateService.t("TUIChat.语音播放失败")}`;
      Toast({
        message,
        type: TOAST_TYPE.ERROR,
        duration: 2000,
      });
      return;
    }
    audioRef.value.play();
    if (!audioIconTimer) {
      audioIconTimer = setInterval(() => {
        currentAudioIconIndex.value = (currentAudioIconIndex.value + 1) % audioIcons.length;
      }, 500);
    }
    
  } catch (e) {
    console.warn(e);
  }
  isAudioPlaying.value = true;
  if (message.value.flow === 'in') {
    emits('setAudioPlayed', message.value.ID);
  }
}

function initAudioIcon() {
  clearInterval(audioIconTimer);
  audioIconTimer = null;
  currentAudioIconIndex.value = 2;
}

function onAudioEnded() {
  isAudioPlaying.value = false;
  initAudioIcon();
}

function onAudioPaused() {
  isAudioPlaying.value = false;
  initAudioIcon();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["message-audio", [
      _unref(isMobile) && 'message-audio-h5',
      _unref(message).flow === 'out' && 'reserve',
      _unref(message).hasRiskContent && 'disable',
    ]]),
    onClick: _withModifiers(play, ["stop"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(Icon, {
        class: _normalizeClass({icon:true,play: _unref(isAudioPlaying)}),
        width: "16px",
        height: "16px",
        file: _unref(currentAudioIcon)
      }, null, 8, ["class", "file"])
    ]),
    _createElementVNode("span", {
      class: "time",
      style: _normalizeStyle({ width: `${_unref(data).second * 2 + 20}px` })
    }, _toDisplayString(_unref(data).second || 1) + "\" ", 5),
    _createElementVNode("audio", {
      ref_key: "audioRef",
      ref: audioRef,
      src: _unref(audioUrl)
    }, null, 8, _hoisted_2)
  ], 2))
}
}

})